import React from "react";

import { AxiomTooltipNew } from "../AxiomTooltip/AxiomTooltip.jsx";

import AxiomBarChartHeader from "./AxiomBarChartHeader";
import AxiomBarChartTable from "./AxiomBarChartTable";

import { Utils } from "./Utils.js";

import Unsorted from "./unsort.svg";
import SortDown from "./sortdown.svg";
import SortUp from "./sortup.svg";
import IoAndroidSearch from "react-icons/lib/io/android-search";

import "./AxiomBarChart.scss";

export default class AxiomBarChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipShow: false
    };
  }

  componentDidMount() {
    $(".AxiomBarChartScrollable").addClass("activeScroll");
  }

  toggleSort = (colData, index) => {
    var sortBy =
      colData.sorting == ""
        ? "asc"
        : colData.sorting == "desc"
        ? "asc"
        : "desc";

    var sortingCol = {
      col: colData.col,
      sorting: sortBy
    };

    this.props.columnData.forEach(d => {
      d.sorting =
        sortingCol && sortingCol.col == d.col ? sortingCol.sorting : "";
    });

    var barChartData = this.sortData(
      this.props.barChartData,
      sortingCol.col,
      sortingCol.sorting
    );

    this.setState({
      sortingCol: sortingCol,
      barChartData: barChartData
    });
  }

  sortData(data, col, sortBy) {
    if (sortBy == "asc") {
      data = data.sort((a, b) => {
        a = a[col].text;
        b = b[col].text;
        if (typeof a === "string") {
          a = a.toUpperCase();
          b = b.toUpperCase();
        }

        if (a < b) return -1;
        return 1;
      });
    } else {
      data = data.sort((a, b) => {
        a = a[col].text;
        b = b[col].text;

        if (typeof a === "string") {
          a = a.toUpperCase();
          b = b.toUpperCase();
        }

        if (a < b) return 1;
        return -1;
      });
    }

    return data;
  }

  render() {
    let localBarChartData = this.props.barChartData;
    let component = this;
    localBarChartData = localBarChartData.filter(function(item) {
      return component.props.columnData.some(colData => {
        return Utils._searchAll(
          colData.fieldName == component.props.searchFieldName
            ? component.props.searchQuery
            : "",
          item,
          {}
        );
      });
    });

    return (
      <div className="AxiomBarChartView_Container">
        {localBarChartData && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <AxiomBarChartHeader
              columnData={this.props.columnData}
              openSearchbar={this.props.openSearchbar || null}
              hideSortIcons={this.props.hideSortIcons}
              unSortIcon={this.props.unSortIcon}
              sortDownIcon={this.props.sortDownIcon}
              sortUpIcon={this.props.sortUpIcon}
              setSearchBarRef={this.props.setSearchBarRef || null}
              handleSearchQuery={this.props.handleSearchQuery || null}
              toggleSort={
                this.props.defaultSorting
                  ? this.toggleSort
                  : this.props.toggleSort
              }/>
            {this.props.stickySummary && this.props.summaryData && (
              <div
                className="AxiomBarChartTable"
                style={{
                  order: this.props.summaryOrder ? this.props.summaryOrder : 0
                }}>
                <div style={{ display: "inline-block" }}>
                  <div
                    className={
                      "AxiomBarChartView_TableBodyRow AxiomBarChartView_Summary " +
                      (this.props.selectedSummary
                        ? "AxiomBarChartView_TableBodyRowSelected"
                        : "")
                    }>
                    {this.props.summaryData.map((item, index) => {
                      return this.props.columnData.map((colData, index) => {
                        let data = item[colData.col];
                        return (
                          <div
                            key={index}
                            className="AxiomBarChartView_TableBodyItem AxiomBarChartView_TableBodySelectable AxiomBarChartView_TableBodyItemFirst"
                            style={data.style ? data.style : item.style}>
                            <div className="AxiomBarChartView_Bar">
                              {data.number != null ||
                              (data.absoluteNumber != null &&
                                data.height != null) ? (
                                <div
                                  className={
                                    "AxiomBarChartView_Bar_ProgressTrack"
                                  }>
                                  <div
                                    style={{
                                      width:
                                        data.number == null
                                          ? data.absoluteNumber == null
                                            ? "100%"
                                            : data.absoluteNumber + "px"
                                          : data.number + "%",
                                      background:
                                        data.background == null
                                          ? null
                                          : data.background,
                                      height: data.height
                                        ? data.height == null
                                          ? "100%"
                                          : data.height + "px"
                                        : "100%",
                                      top:
                                        data.height == null
                                          ? 0
                                          : "calc(50% - " +
                                            data.height / 2 +
                                            "px)",
                                      left:
                                        data.barCenterPointPercent == null
                                          ? 0
                                          : `${data.barCenterPointPercent}%`
                                    }}
                                    className={
                                      "AxiomBarChartView_Bar_ProgressFill"
                                    }
                                  />
                                </div>
                              ) : null}
                              <div
                                className={
                                  "AxiomBarChartViewValue" +
                                  (data.number != null
                                    ? " AxiomBarChartViewValue_Fill"
                                    : "")
                                }>
                                {data.number == null ? (
                                  <span>
                                    {data.format
                                      ? Utils.apply_format(
                                          parseFloat(data.text),
                                          data.format,
                                          data.unit
                                        )
                                      : data.text}
                                  </span>
                                ) : (
                                  <span>
                                    {data.format
                                      ? Utils.apply_format(
                                          parseFloat(data.text),
                                          data.format,
                                          data.unit
                                        )
                                      : data.text}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      });
                    })}
                  </div>
                </div>
              </div>
            )}
            <AxiomBarChartTable
              id={this.props.id}
              barChartData={localBarChartData}
              height={this.props.height}
              columnData={this.props.columnData}
              rowHeight={this.props.rowHeight}
              arrFilterData={this.props.arrFilterData}
              selectedCol={this.props.selectedCol}
              searchFieldName={this.props.searchFieldName}
              searchQuery={this.props.searchQuery}
              addToDrillDown={this.props.addToDrillDown}
              />
          </div>
        )}
      </div>
    );
  }
}
